<template>
  <div>
    <!-- // agrupar técnico, matricula antes de produtor/fazenda, tamanho da coluna de valor -->
    <relatorio
      :headers="headersRel"
      :dados="relatorioList(relatorio)"
      :filtro-config="filtroConfig"
      :exportar-p-d-f="true"
      :exportar-x-l-s-x="true"
      @exportarPdf="tipoRelatorioPdf"
      @exportarXlsx="tipoRelatorioXlsx"
      @filtros-selecionados="verificaFiltro"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td
          v-if="item.itens && item.itens.length > 0"
          :colspan="headers.length"
        >
          <div>
            <v-simple-table
              dense
              class="mb-5 mt-5"
              style="border: 1px solid lightgrey; max-width: 85%;"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      colspan="6"
                      class="black--text font-weight-black"
                    >
                      Itens do serviço:
                    </th>
                  </tr>
                  <tr>
                    <th>Matrícula</th>
                    <th style="width: 50%;">
                      Produtor/Fazenda
                    </th>
                    <th>Data</th>
                    <th class="text-right">
                      Quantidade
                    </th>
                    <th class="text-right">
                      Valor Unitário
                    </th>
                    <th class="text-right">
                      Valor Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(itemRelacionado, index) in item.itens">
                    <template>
                      <tr
                        v-if="temFiltroTecnico && itemRelacionado.tecnico_nome"
                        :key="`tecnico-nome-${index}`"
                      >
                        <td colspan="6">
                          Técnico: {{ itemRelacionado.tecnico_nome }}
                        </td>
                      </tr>
                    </template>
                    <template>
                      <tr :key="`item-${index}`">
                        <td>{{ itemRelacionado.cod_produtor }}</td>
                        <td>{{ itemRelacionado.fazenda_produtor_nome }}</td>
                        <td>{{ itemRelacionado.data_atendimento }}</td>
                        <td class="text-right">
                          {{ currencyFormatter(itemRelacionado.quantidade) }}
                        </td>

                        <td class="text-right">
                          R$ {{ currencyFormatter(itemRelacionado.valor_unitario) }}
                        </td>

                        <td
                          class="text-right"
                          colspan="2"
                        >
                          R$ {{ currencyFormatter(itemRelacionado.valor_total) }}
                        </td>
                      </tr>
                    </template>
                    <tr
                      v-if="itemRelacionado.valor_total_servico"
                      :key="`total-servico-${index}`"
                      style="font-weight: bold;"
                    >
                      <td
                        colspan="2"
                        class="text-right"
                      >
                        Total do serviço:
                      </td>

                      <td colspan="1" />

                      <td class="text-right">
                        {{ itemRelacionado.quantidade_servico }}
                      </td>
                      <td
                        class="text-right"
                        colspan="2"
                      >
                        R$ {{ currencyFormatter(itemRelacionado.valor_total_servico) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </td>
        <td v-else>
          Nenhum registro encontrado
        </td>
      </template>
    </relatorio>
  </div>
</template>

<script>
  import { currencyFormatter } from '../../utils/formatter'
  import Relatorio from './Relatorio.vue'
  import { BOOTSTRAP_PRODUTOR_RELATORIO } from '@/store/modules/produtores'
  import { BOOTSTRAP } from '@/store/modules/relatorio'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { mapActions } from 'vuex/dist/vuex.common.js'
  import XLSX from 'xlsx'
  import { BOOTSTRAP_SERVICOS_RELATORIO } from '@/store/modules/servicos'
  import Swal from 'sweetalert2'
  import { BOOTSTRAP_TECNICO_RELATORIO } from '@/store/modules/tecnicos'
import { BOOTSTRAP_FORNECEDOR_RELATORIO } from '@/store/modules/fornecedores'
  export default {
    components: {
      Relatorio,
    },
    data () {
      return {
        currencyFormatter,
        temFiltroTecnico: false,
      }
    },
    computed: {
      ...mapState('relatorio', ['ready', 'relatorio', 'filtrosData']),
      ...mapState('fornecedores', ['listFornecedores']),
      ...mapState('produtores', ['listProdutores']),
      ...mapState('servicos', ['listServicos']),
      ...mapState('tecnicos', ['listTecnicos']),
      headersRel () {
        return [
          { align: 'left', sortable: false, text: '', value: 'data-table-expand', width: '40px' },
          { align: 'left', sortable: true, text: 'Código', value: 'codigo', width: 'auto' },
          { align: 'left', sortable: true, text: 'Serviço', value: 'servico', width: 'auto' },
        ]
      },
      filtroConfig () {
        return [
          {
            filtro: 'fornecedor',
            items: this.listFornecedores,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione uma empresa',
            value: null,
            multiple: false,
          },
          {
            filtro: 'produtor',
            items: this.listProdutores,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um produtor',
            value: [],
          },
          {
            filtro: 'servico',
            items: this.listServicos,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um serviço',
            value: [],
          },
          {
            filtro: 'tecnico',
            items: this.listTecnicos,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um técnico',
            value: [],
          },
        ]
      },
    },
    mounted () {
      this.BOOTSTRAP_PRODUTOR_RELATORIO()
      this.BOOTSTRAP_SERVICOS_RELATORIO()
      this.BOOTSTRAP_TECNICO_RELATORIO()
      this.BOOTSTRAP_FORNECEDOR_RELATORIO()
    },
    methods: {
      ...mapActions('fornecedores', [BOOTSTRAP_FORNECEDOR_RELATORIO]),
      ...mapActions('produtores', [BOOTSTRAP_PRODUTOR_RELATORIO]),
      ...mapActions('relatorio', [BOOTSTRAP]),
      ...mapActions('servicos', [BOOTSTRAP_SERVICOS_RELATORIO]),
      ...mapActions('tecnicos', [BOOTSTRAP_TECNICO_RELATORIO]),
      verificaFiltro (filtro) {
        filtro.tecnico ? this.temFiltroTecnico = true : this.temFiltroTecnico = false
      },
      relatorioList (dados) {
        if (!Array.isArray(dados)) return []

        return dados.map(servico => {
          const dados_servico = []

          servico.itens && Array.isArray(servico.itens) && servico.itens.forEach((item, index) => {
            const dataFormatada = item.data_atendimento
              ? moment(item.data_atendimento).format('DD/MM/YYYY')
              : ''
            dados_servico.push({
              data_atendimento: dataFormatada,
              cod_produtor: item.cod_produtor,
              produtor: item.produtor,
              fazenda_nome: item.fazenda_nome,
              fazenda_produtor_nome: `${item.produtor} - ${item.fazenda_nome}`,
              valor_unitario: item.valor_unitario,
              quantidade: item.quantidade,
              valor_total: item.valor_total,
              quantidade_servico: item.quantidade_servico,
              valor_total_servico: item.valor_total_servico,
              tecnico_nome: item.tecnico_nome,
            })
          })
          return {
            id: servico.id,
            codigo: servico.codigo,
            servico: servico.servico,
            empresa: servico.empresa,
            itens: dados_servico,
          }
        })
      },
      tipoRelatorioXlsx () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportXlsx('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportXlsx('analitico')
          }
        })
      },
        async exportXlsx (tipoRelatorio) {
        const dados = this.relatorioList(this.relatorio)

        const wb = XLSX.utils.book_new()
        const ws_data = []

        if (dados.length > 0) {
          let valorTotalGeral = 0
          let quantidadeTotalGeral = 0

          const dadosAgrupadosPorEmpresa = dados.reduce((acc, servico) => {
            const empresa = servico.empresa || 'Sem empresa'

            if (!acc[empresa]) {
              acc[empresa] = []
            }

            acc[empresa].push(servico)

            return acc
          }, {})

          Object.entries(dadosAgrupadosPorEmpresa).forEach(([empresa, servicosEmpresa]) => {
            let valorTotalEmpresa = 0
            let quantidadeTotalEmpresa = 0

            ws_data.push([`Empresa: ${empresa}`])
            ws_data.push([''])

            servicosEmpresa.forEach(dado => {
              ws_data.push(['Código', 'Serviço'])
              ws_data.push([dado.codigo, dado.servico])

              if (tipoRelatorio === 'analitico') {
                ws_data.push([
                  'Matrícula',
                  'Produtor/Fazenda',
                  'Data do Atendimento',
                  'Quantidade',
                  'Valor',
                  'Valor Total',
                ])

                dado.itens.forEach(item => {
                  const quantidade = Number(item.quantidade) || 0
                  const valorTotal = Number(item.valor_total) || 0
                  const valorUnitario = Number(item.valor_unitario) || 0

                  quantidadeTotalEmpresa += quantidade
                  valorTotalEmpresa += valorTotal

                  quantidadeTotalGeral += quantidade
                  valorTotalGeral += valorTotal

                  if (this.temFiltroTecnico && item.tecnico_nome) {
                    ws_data.push([`Técnico: ${item.tecnico_nome}`])
                  }

                  ws_data.push([
                    { v: item.cod_produtor, t: 's', s: { alignment: { horizontal: 'left' } } },
                    item.fazenda_produtor_nome,
                    item.data_atendimento,
                    { v: quantidade, t: 'n', s: { alignment: { horizontal: 'right' } } },
                    { v: valorUnitario, t: 'n', s: { alignment: { horizontal: 'right' } } },
                    { v: valorTotal, t: 'n', s: { alignment: { horizontal: 'right' } } },
                  ])

                  if (item.valor_total_servico != null) {
                    ws_data.push([
                      '',
                      '',
                      'Total Serviço',
                      {
                        v: Number(item.quantidade_servico) || 0,
                        t: 'n',
                        s: { alignment: { horizontal: 'right' } },
                      },
                      '',
                      {
                        v: Number(item.valor_total_servico) || 0,
                        t: 'n',
                        s: { alignment: { horizontal: 'right' } },
                      },
                    ])
                  }
                })

                ws_data.push(['', '', '', '', '', ''])
              } else if (tipoRelatorio === 'sintetico') {
                ws_data.push([
                  'Matrícula',
                  'Produtor/Fazenda',
                  'Quantidade',
                  'Valor',
                  'Valor Total',
                ])

                const acumuladoProdutor = []

                let valorTotalServico = 0
                let quantidadeTotalServico = 0

                dado.itens.forEach(item => {
                  const quantidade = Number(item.quantidade) || 0
                  const valorTotal = Number(item.valor_total) || 0
                  const valorUnitario = Number(item.valor_unitario) || 0

                  valorTotalServico += valorTotal
                  quantidadeTotalServico += quantidade

                  valorTotalEmpresa += valorTotal
                  quantidadeTotalEmpresa += quantidade

                  valorTotalGeral += valorTotal
                  quantidadeTotalGeral += quantidade

                  const produtorEncontrado = acumuladoProdutor.findIndex(p =>
                    p.cod_produtor === item.cod_produtor &&
                    p.codigo === dado.codigo,
                  )

                  if (produtorEncontrado !== -1) {
                    acumuladoProdutor[produtorEncontrado].quantidade += quantidade
                    acumuladoProdutor[produtorEncontrado].valor_total += valorTotal
                  } else {
                    acumuladoProdutor.push({
                      tecnico_nome: item.tecnico_nome,
                      codigo: dado.codigo,
                      produtor: item.fazenda_produtor_nome,
                      cod_produtor: item.cod_produtor,
                      quantidade,
                      valor_unitario: valorUnitario,
                      valor_total: valorTotal,
                    })
                  }
                })

                acumuladoProdutor.forEach(item => {
                  const quantidade = Number(item.quantidade) || 0
                  const valorTotal = Number(item.valor_total) || 0
                  const valorUnitarioMedio = quantidade > 0
                    ? valorTotal / quantidade
                    : 0

                  if (this.temFiltroTecnico && item.tecnico_nome) {
                    ws_data.push([`Técnico: ${item.tecnico_nome}`])
                  }

                  ws_data.push([
                    item.cod_produtor,
                    item.produtor,
                    {
                      v: quantidade,
                      t: 'n',
                      s: { alignment: { horizontal: 'right' } },
                    },
                    {
                      v: valorUnitarioMedio,
                      t: 'n',
                      s: { alignment: { horizontal: 'right' } },
                    },
                    {
                      v: valorTotal,
                      t: 'n',
                      s: { alignment: { horizontal: 'right' } },
                    },
                  ])
                })

                ws_data.push([
                  '',
                  'Total Serviço',
                  {
                    v: quantidadeTotalServico,
                    t: 'n',
                    s: { alignment: { horizontal: 'right' } },
                  },
                  '',
                  {
                    v: valorTotalServico,
                    t: 'n',
                    s: { alignment: { horizontal: 'right' } },
                  },
                ])

                ws_data.push(['', '', '', '', ''])
              }
            })

            if (tipoRelatorio === 'analitico') {
              ws_data.push([
                '',
                '',
                'Total Empresa',
                {
                  v: quantidadeTotalEmpresa,
                  t: 'n',
                  s: { alignment: { horizontal: 'right' } },
                },
                '',
                {
                  v: valorTotalEmpresa,
                  t: 'n',
                  s: { alignment: { horizontal: 'right' } },
                },
              ])
            } else {
              ws_data.push([
                '',
                'Total Empresa',
                {
                  v: quantidadeTotalEmpresa,
                  t: 'n',
                  s: { alignment: { horizontal: 'right' } },
                },
                '',
                {
                  v: valorTotalEmpresa,
                  t: 'n',
                  s: { alignment: { horizontal: 'right' } },
                },
              ])
            }

            ws_data.push(['', '', '', '', '', ''])
          })

          if (tipoRelatorio === 'analitico') {
            ws_data.push([
              '',
              '',
              'Total Geral',
              {
                v: quantidadeTotalGeral,
                t: 'n',
                s: { alignment: { horizontal: 'right' } },
              },
              '',
              {
                v: valorTotalGeral,
                t: 'n',
                s: { alignment: { horizontal: 'right' } },
              },
            ])
          } else {
            ws_data.push([
              '',
              'Total Geral',
              {
                v: quantidadeTotalGeral,
                t: 'n',
                s: { alignment: { horizontal: 'right' } },
              },
              '',
              {
                v: valorTotalGeral,
                t: 'n',
                s: { alignment: { horizontal: 'right' } },
              },
            ])
          }
        } else {
          ws_data.push(['Código', 'Serviço'])
          ws_data.push(['', ''])
          ws_data.push(['Matrícula', 'Produtor/Fazenda', 'Data do Atendimento', 'Quantidade', 'Valor', 'Valor Total'])
          ws_data.push(['', '', '', '', '', ''])
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data)

        const colWidths = ws_data[0].map((_, colIndex) => {
          return ws_data.reduce((maxWidth, currentRow) => {
            let cellValue = currentRow[colIndex]

            if (cellValue && typeof cellValue === 'object' && cellValue.v !== undefined) {
              cellValue = cellValue.v.toString()
            } else if (cellValue === null || cellValue === undefined) {
              cellValue = ''
            } else {
              cellValue = cellValue.toString()
            }

            return Math.max(maxWidth, cellValue.length)
          }, 0)
        })

        ws['!cols'] = colWidths.map(width => ({
          wch: Math.min(Math.max(width + 2, 8), 50),
        }))

        XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },
      tipoRelatorioPdf () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportPdf('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportPdf('analitico')
          }
        })
      },
        async exportPdf (tipoRelatorio = null) {
        const dados = this.relatorioList(this.relatorio)

        const relatorioAnalitico = tipoRelatorio === 'analitico'

        let valorTotalGeral = 0
        let quantidadeTotalGeral = 0

        const data_inicial = moment(this.filtrosData.data_inicial).format('DD/MM/YYYY')
        const data_final = moment(this.filtrosData.data_final).format('DD/MM/YYYY')

        const doc = new JsPDF({ orientation: 'portrait' })

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const fontSize = 10
        const margin = { left: 10, right: 10, bottom: 10, top: 32 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addHeader () {
          doc.addImage(logo, 'png', 10, 5, 38, 14)
          doc.setFontSize(16)
          doc.text('Resumo dos Serviços', docWidth / 2, 15, { align: 'center' })

          doc.setFontSize(10)
          doc.text(dateNow, docWidth - 10, 15, { align: 'right' })
          doc.text(horaNow, docWidth - 10, 20, { align: 'right' })

          doc.setDrawColor(0, 0, 0)
          doc.setLineWidth(0.2)
          doc.line(10, 25, docWidth - 10, 25)

          doc.text(`Período de ${data_inicial} até ${data_final}`, 12, 30)
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()

          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        const headerRow = [
          { content: 'Matrícula', styles: { fontStyle: 'bold', halign: 'left', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } },
          { content: 'Produtor/Fazenda', styles: { fontStyle: 'bold', halign: 'left', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } },
          ...(relatorioAnalitico
            ? [{ content: 'Data', styles: { fontStyle: 'bold', halign: 'left', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } }]
            : []),
          { content: 'Qtde.', styles: { fontStyle: 'bold', halign: 'right', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } },
          { content: 'Valor Unitário', styles: { fontStyle: 'bold', halign: 'right', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } },
          { content: 'Valor Total', styles: { fontStyle: 'bold', halign: 'right', lineColor: [0, 0, 0], lineWidth: { top: 0.2, bottom: 0.2 } } },
        ]

        const columnStyles = {}
        let colIndex = 0

        columnStyles[colIndex++] = { cellWidth: 'auto', halign: 'left' }
        columnStyles[colIndex++] = { cellWidth: 98, halign: 'left', overflow: 'ellipsize' }

        if (relatorioAnalitico) {
          columnStyles[colIndex++] = { cellWidth: 15, halign: 'left' }
        }

        columnStyles[colIndex++] = { cellWidth: 'auto', halign: 'right' }
        columnStyles[colIndex++] = { cellWidth: 'auto', halign: 'right' }
        columnStyles[colIndex++] = { cellWidth: 'auto', halign: 'right' }

        const servicosAgrupadosPorEmpresa = dados.reduce((acc, item) => {
          const empresa = item.empresa || 'Sem empresa'

          if (!acc[empresa]) {
            acc[empresa] = []
          }

          acc[empresa].push(item)

          return acc
        }, {})

        Object.entries(servicosAgrupadosPorEmpresa).forEach(([empresa, servicos]) => {
          const allTableData = []

          let valorTotalEmpresa = 0
          let quantidadeTotalEmpresa = 0

          allTableData.push([
            {
              content: `Empresa: ${empresa}`,
              colSpan: relatorioAnalitico ? 6 : 5,
              styles: { fontStyle: 'bold', fontSize: 9 },
            },
          ])

          servicos.forEach(item => {
            allTableData.push([
              {
                content: `Serviço        ${item.codigo}        ${item.servico}`,
                colSpan: relatorioAnalitico ? 6 : 5,
                styles: { fontStyle: 'bold' },
              },
            ])

            let itensProcessados = []

            if (!relatorioAnalitico) {
              const agrupado = item.itens.reduce((acc, atual) => {
                const chave = atual.cod_produtor + '|' + atual.fazenda_produtor_nome

                if (!acc[chave]) {
                  acc[chave] = {
                    cod_produtor: atual.cod_produtor,
                    fazenda_produtor_nome: atual.fazenda_produtor_nome,
                    tecnico_nome: atual.tecnico_nome,
                    quantidade: 0,
                    valor_unitario: 0,
                    valor_total: 0,
                  }
                }

                acc[chave].quantidade += Number(atual.quantidade) || 0
                acc[chave].valor_total += Number(atual.valor_total) || 0

                return acc
              }, {})

              const valorTotalServico = Object.values(agrupado)
                .reduce((soma, item) => soma + (Number(item.valor_total) || 0), 0)

              const quantidadeServico = Object.values(agrupado)
                .reduce((soma, item) => soma + (Number(item.quantidade) || 0), 0)

              itensProcessados = Object.values(agrupado).map((prod, index, array) => {
                const ultimo = index === array.length - 1

                return {
                  ...prod,
                  valor_unitario: prod.quantidade > 0
                    ? Math.trunc((prod.valor_total / prod.quantidade) * 100) / 100
                    : 0,
                  valor_total_servico: ultimo ? valorTotalServico : null,
                  quantidade_servico: ultimo ? quantidadeServico : null,
                }
              })
            } else {
              itensProcessados = item.itens
            }

            itensProcessados.forEach(itemServico => {
              if (this.temFiltroTecnico && itemServico.tecnico_nome) {
                allTableData.push([
                  {
                    content: `Técnico: ${itemServico.tecnico_nome}`,
                    colSpan: relatorioAnalitico ? 6 : 5,
                  },
                ])
              }

              allTableData.push([
                { content: itemServico.cod_produtor },
                { content: itemServico.fazenda_produtor_nome },
                ...(relatorioAnalitico
                  ? [{ content: itemServico.data_atendimento }]
                  : []),
                { content: itemServico.quantidade },
                { content: currencyFormatter(itemServico.valor_unitario, 2) },
                { content: currencyFormatter(itemServico.valor_total, 2) },
              ])

              if (itemServico.valor_total_servico != null) {
                const totalColSpan = relatorioAnalitico ? 3 : 2

                allTableData.push([
                  { content: 'Total do serviço', colSpan: totalColSpan, styles: { fontStyle: 'bold', halign: 'right' } },
                  { content: itemServico.quantidade_servico, colSpan: 1, styles: { fontStyle: 'bold', halign: 'right' } },
                  { content: `R$ ${currencyFormatter(itemServico.valor_total_servico)}`, colSpan: 2, styles: { fontStyle: 'bold', halign: 'right' } },
                ])
              }

              valorTotalEmpresa += Number(itemServico.valor_total) || 0
              quantidadeTotalEmpresa += Number(itemServico.quantidade) || 0

              valorTotalGeral += Number(itemServico.valor_total) || 0
              quantidadeTotalGeral += Number(itemServico.quantidade) || 0
            })
          })

          allTableData.push([
            {
              content: 'Total da empresa',
              colSpan: relatorioAnalitico ? 3 : 2,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
            {
              content: quantidadeTotalEmpresa,
              colSpan: 1,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
            {
              content: `R$ ${currencyFormatter(valorTotalEmpresa)}`,
              colSpan: 2,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
          ])

          doc.autoTable({
            head: [headerRow],
            body: allTableData,
            theme: 'plain',
            startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 32,
            margin,
            styles: { fontSize: 7, cellPadding: 1.2 },
            columnStyles,
            didDrawPage: () => addHeader(),
          })
        })

        const totalColSpan = relatorioAnalitico ? 3 : 2

        doc.autoTable({
          body: [[
            {
              content: 'Total Geral',
              colSpan: totalColSpan,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
            {
              content: quantidadeTotalGeral,
              colSpan: 1,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
            {
              content: `R$ ${currencyFormatter(valorTotalGeral)}`,
              colSpan: 2,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
          ]],
          theme: 'plain',
          startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 4 : 32,
          margin,
          styles: { fontSize: 7, cellPadding: 1.2 },
        })

        const totalPages = doc.internal.getNumberOfPages()

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i)
          doc.setFontSize(fontSize - 1)
          doc.text(dateNow, 12, docHeight - 10)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - 10, { align: 'center' })
          doc.text(`Página ${i} de ${totalPages}`, docWidth - 10, docHeight - 10, { align: 'right' })
        }

        doc.save('Resumo dos Serviços.pdf')
      }
    },
  }
</script>
